import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import VehicleSelectBox from "../../../dump/menuComponents/VehicleSelectBox";
import CustomButton from "../../../CustomButton";
import { getDevicesList } from "../../../../action/DeviceActions";
import { ErrorLogger } from "../../../../../../logger";

export default function SelectVehicleModal (props) {
    const { t } = useTranslation('translation', { keyPrefix: 'reportsPage.standardReportTable' });
    const { show, selectedVehicles, setSelectedVehicles, onHide } = props;
    const company = useSelector(state => state.company.company);
    const [totalVehicles, setTotalVehicles] = useState([]);
    const [selectedVehicleIds, setSelectedVehicleIds] = useState(selectedVehicles || []);

    useEffect(() => {
        getDevicesList(company.company_id)
            .then((res) => {
                const { devices } = res.data.response || [];
                setTotalVehicles(devices);
            })
            .catch((error) => {
                ErrorLogger(error);
            });
    }, []);

    const onToggleVehicle = (vehicles) => {
        setSelectedVehicleIds(vehicles);
    };

    const onHideModal = () => {
        onHide();
    };

    const onOkClick = () => {
        setSelectedVehicles(selectedVehicleIds);
        onHide();
    };

    return (
        <Modal
            size='lg'
            show={show}
            onHide={onHideModal}
            className="reports-modal modal-lg-size"
        >
            <Modal.Header closeButton>
                <Modal.Title>{t('selectVehicles')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {totalVehicles.length > 0 &&
                    <VehicleSelectBox
                        reportLayout
                        vehicles={totalVehicles}
                        selectedVehicleIds={selectedVehicleIds}
                        onToggle={onToggleVehicle}
                    />
                }
            </Modal.Body>
            <Modal.Footer>
                <CustomButton
                    variant='primary-outline'
                    onClick={onHideModal}
                >
                    {t('btnBack')}
                </CustomButton>
                <CustomButton
                    variant='primary-outline'
                    onClick={onOkClick}
                >
                    {t('btnOk')}
                </CustomButton>
            </Modal.Footer>
        </Modal>
    )
}
